import React from 'react'

import {Typography} from '../typography'
import {classes} from './StepIcon.classes'

type Props = {
  step: number
}

const StepIcon: React.FC<Props> = ({step}) => {
  return (
    <Typography className={classes.stepIcon} group="normal" thickness="medium" variant="title4">
      <div>{step}</div>
    </Typography>
  )
}

export default StepIcon
